import { Injectable }     from '@angular/core';
import {
	IDevice,
	IMedia,
	IScreen
}                         from '@app/core/interfaces/media-interfaces';
import { LoggerService }  from '@app/shared/services/logger.service';
import {
	CustomBreakpointsEnum,
	DeviceOrientationEnum,
	DeviceTypeEnum
}                         from '@appConfig/media-config';
import { UiStoreActions } from '@core/store/feature/ui';
import { Store }          from '@ngrx/store';
import { fromEvent }      from 'rxjs';
import {
	debounceTime,
	tap
}                         from 'rxjs/operators';


@Injectable( {
	providedIn: 'root'
} )
export class MediaService {

	private screen: IScreen;

	private content: IScreen;

	private device: IDevice;

	private sidebarWidth = 302;

	private minWidthSidebarLimit = 992;

	constructor(
		private store$: Store,
		private logger: LoggerService
	) {
		this.screen = { width: null, height: null };
		this.content = { width: null, height: null };
		this.device = { type: null, orientation: null };
		this.init();
	}

	private getDevice( width: number ): DeviceTypeEnum {
		return width < CustomBreakpointsEnum.MOBILE_MAX_WIDTH
					 ? DeviceTypeEnum.MOBILE
					 : width < CustomBreakpointsEnum.TABLET_MAX_WIDTH
						 ? DeviceTypeEnum.TABLET
						 : DeviceTypeEnum.DESKTOP;
	}

	private getOrientation( width: number, height: number ): DeviceOrientationEnum {
		return width > height
					 ? DeviceOrientationEnum.LANDSCAPE
					 : DeviceOrientationEnum.PORTRAIT;
	}

	init(): void {
		this.logger.debug( 'ScreenService ready' );
		this.store$.dispatch( new UiStoreActions.SetMediaAction( this.getMediaData( window ) ) );

		fromEvent( window, 'resize' )
		.pipe(
			debounceTime( 200 ),
			tap( ( ev ) => {
				this.store$.dispatch( new UiStoreActions.SetMediaAction( this.getMediaData( window ) ) );
			} )
		).subscribe();
	}

	getMediaData( window: Window ): IMedia {
		this.screen = {
			width: window.innerWidth,
			height: window.innerHeight
		};

		this.content = {
			width: window.innerWidth >= this.minWidthSidebarLimit ? window.innerWidth - this.sidebarWidth : window.innerWidth,
			height: window.innerHeight
		};

		this.device = {
			type: this.getDevice( this.screen.width ),
			orientation: this.getOrientation( this.screen.width, this.screen.height )
		};

		const media: IMedia = {
			screen: { ...this.screen },
			device: { ...this.device },
			content: { ...this.content },
			minWidthSidebarLimit: this.minWidthSidebarLimit,
			sidebarWidth: this.sidebarWidth
		};

		this.logger.debug( 'media: ', media );

		return media;
	}
}
